// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__15kxz","requiredAsterisk":"Info_requiredAsterisk__2qY7K"};